/**
 * Assignment Entity
 * Represents a professor-subject assignment
 */
export interface AssignmentProps {
  id: number;
  subjectId: number;
  subjectName: string;
  professor: string;
}

export class Assignment {
  private readonly props: AssignmentProps;

  constructor(props: AssignmentProps) {
    this.props = props;
  }

  get id(): number {
    return this.props.id;
  }

  get subjectId(): number {
    return this.props.subjectId;
  }

  get subjectName(): string {
    return this.props.subjectName;
  }

  get professor(): string {
    return this.props.professor;
  }

  toPlainObject(): AssignmentProps {
    return { ...this.props };
  }
}
